import bmAxiosClient from "../../GenAPI/axiosClient";

const genRep = (data) => bmAxiosClient.get('/api/reports/genRep', {params: data});        

export default {genRep};
